import { createRouter, createWebHistory } from "vue-router";
import layout from "@/layout/index.vue";
import store from "@/store/store";

const routes = [
  // DEFAULT ROUTE
  {
    path: "/",
    name: "default",
    component: function () {
      return import("../components/Map.vue");
    },
  },
  // PARAMETERS ROUTE (admin only)
  {
    path: "/parameters",
    name: "ParametersOverlayHome",
    component: function () {
      return import("../components/Parameters.vue");
    },
    meta: {
      breadcrumbName: "parameters",
      adminOnly: true,
    },
  },
  // GEBRUIKERSVALIDATIE ROUTE (admin only)
  {
    path: "/gebruikersvalidatie",
    name: "UsersValidationOverlay",
    component: function () {
      return import("../components/UsersValidation.vue");
    },
    meta: {
      breadcrumbName: "gebruikersvalidatie",
      adminOnly: true,
    },
  },
  // GEBRUIKERS OVERZICHT ROUTE (admin only)
  {
    path: "/gebruikers",
    name: "UsersOverview",
    component: function () {
      return import("../components/UsersOverview.vue");
    },
    meta: {
      breadcrumbName: "gebruikers",
      adminOnly: true,
    },
  },
  // NIEUWE GEBRUIKER (admin only)
  {
    path: "/gebruikers/nieuw",
    name: "UserAdd",
    component: function () {
      return import("../components/UserAdd.vue");
    },
    meta: {
      breadcrumbName: "gebruiker-toevoegen",
      adminOnly: true,
    },
  },
  // GEBRUIKER BEWERKEN (admin only)
  {
    path: "/gebruikers/:id/bewerken",
    name: "UserEdit",
    component: function () {
      return import("../components/UserEdit.vue");
    },
    meta: {
      breadcrumbName: "gebruiker-bewerken",
      adminOnly: true,
    },
  },
  // EXPORT (admin only)
  {
    path: "/exporteren",
    name: "Export",
    component: function () {
      return import("../components/Export.vue");
    },
    meta: {
      breadcrumbName: "exporteren",
      adminOnly: true,
    },
  },
  // LOGIN ROUTE
  {
    path: "/aanmelden",
    name: "LoginOverlay",
    component: function () {
      return import("../components/Login.vue");
    },
    meta: {
      breadcrumbName: "aanmelden",
    },
  },
  // WACHTWOORD VERGETEN
  {
    path: "/wachtwoord-vergeten",
    name: "ForgotPassword",
    component: function () {
      return import("../components/ForgotPassword.vue");
    },
    meta: {
      breadcrumbName: "wachtwoord-vergeten",
    },
  },
  // WACHTWOORD RESETTEN
  {
    path: "/wachtwoord-resetten",
    name: "ResetPassword",
    component: function () {
      return import("../components/ResetPassword.vue");
    },
    meta: {
      breadcrumbName: "wachtwoord-resetten",
    },
  },
  // MAP ROUTE
  {
    path: "/kaart",
    name: "Map",
    component: layout,
    meta: {
      breadcrumbName: "kaart",
    },
    children: [
      {
        path: "",
        name: "MapHome",
        component: () => import("../components/Map.vue"),
      },
      {
        path: "/vijver/:id",
        name: "PondDetail",
        component: () => import("../components/PondDetail.vue"),
        meta: {
          breadcrumbName: "vijver",
        },
      },
    ],
  },
  // POND OVERLAY ROUTE
  {
    path: "/vijvers",
    name: "PondOverlay",
    component: layout,
    meta: {
      breadcrumbName: "vijvers",
    },
    children: [
      {
        path: "",
        name: "PondOverlayHome",
        component: () => import("../components/PondOverlay.vue"),
      },
      {
        path: "/vijver/:id",
        name: "PondDetail",
        component: () => import("../components/PondDetail.vue"),
        meta: {
          breadcrumbName: `vijver`,
        },
      },
    ],
  },
  // FOOTER ROUTE
  {
    path: "/footer",
    name: "Footer",
    component: function () {
      return import("../components/Footer.vue");
    },
  },
  // HEADER ROUTE
  {
    path: "/header",
    name: "Header",
    component: function () {
      return import("../components/Header.vue");
    },
  },
  // SESSION OVERLAY ROUTE
  {
    path: "/sessies",
    name: "SessionOverlay",
    component: layout,
    meta: {
      breadcrumbName: "sessies",
    },
    children: [
      {
        path: "",
        name: "SessionOverlayHome",
        component: () => import("../components/SessionOverlay.vue"),
      },
      {
        path: "/sessie/:id",
        name: "SessionDetail",
        component: () => import("../components/SessionDetail.vue"),
        meta: {
          breadcrumbName: "sessie",
        },
      },
    ],
  },
  // TIME TRACKING ROUTES
  {
    path: "/tijdregistratie/dag",
    name: "DailyTimeline",
    component: function () {
      return import("../components/DailyTimeline.vue");
    },
    meta: {
      breadcrumbName: "dagelijkse-tijdlijn",
    },
  },
  {
    path: "/tijdregistratie/jaar",
    name: "YearlyTimeOverview",
    component: function () {
      return import("../components/YearlyTimeOverview.vue");
    },
    meta: {
      breadcrumbName: "jaarlijks-overzicht",
    },
  },
  // ADD POND ROUTES (admin only)
  {
    path: "/vijver-toevoegen",
    name: "AddPond",
    component: function () {
      return import("../components/PondAdd.vue");
    },
    meta: { adminOnly: true },
  },
  {
    path: "/vijver-toevoegen/:region",
    props: true,
    name: "AddPondInRegion",
    component: () => import("../components/PondAdd.vue"),
    meta: { adminOnly: true },
  },
  // EDIT POND (admin only)
  {
    path: "/vijver/:pondid/bewerken",
    props: true,
    name: "EditPond",
    component: () => import("../components/PondEdit.vue"),
    meta: { adminOnly: true },
  },
  // CHART ROUTE (laat voorlopig toe voor user)
  {
    path: "/chart",
    name: "Chart",
    component: function () {
      return import("../components/Chart.vue");
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const role =
    store.state.userRole ||
    localStorage.getItem("hopstats-user-role") ||
    "user";
  if (to.meta && to.meta.adminOnly && role !== "admin") {
    // Redirect user naar kaart als geen admin
    if (from.path === to.path) {
      return next("/kaart");
    }
    return next("/kaart");
  }
  next();
});

export default router;
